/**
 *
 * Asynchronously loads the component for IndividualTransactionsPage
 *
 */
import { lazyLoad } from "utils";

export const IndividualTransactionsPageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.IndividualTransactionsPage
);

export const IndividualTransactionsDetailsPageLazy = lazyLoad(
  () => import("./individual-transactions-details"),
  (module) => module.IndividualTransactionsDetailsPage
);
